import EmailAddress from "../types/core/EmailAddress";
import PhoneNumber from "../types/core/PhoneNumber";
import SchoolAddress from "../types/core/SchoolAddress";
import Address from "../types/core/Address";
import Utility from "./Utility";

class Formatting {
    static formatNumber(value: number, decimalPlaces?: number, naForNull: boolean = false) {
        if (Utility.isNull(value)) {
            return naForNull ? "NA" : "";
        }
        if (decimalPlaces !== undefined) {
            return value.toFixed(decimalPlaces);
        }
        return value.toString();
    }
    static formatISO(date: Date) {
        return date.toISOString();
    }
    static formatImport(date: Date) {
        return `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, "0")}${date.getDate().toString().padStart(2, "0")}`;
    }
    static formatDate(date: Date) {
        return date.toLocaleDateString(navigator.language);
    }
    static formatDateTime(date: Date) {
        return date.toLocaleDateString(navigator.language) + " " + date.toLocaleTimeString(navigator.language, { timeStyle: 'short' });
    }
    static formatISODate(date: Date) {
        return date.toISOString().split("T")[0];
    }
    static formatTime(date: Date) {
        return date.toLocaleTimeString(navigator.language, { timeStyle: 'short' });
    }
    static formatISOTime(date: Date) {
        return date.toISOString().split("T")[1];
    }
    static formatLongDate(date: Date) {
        return date.toLocaleDateString(navigator.language, { dateStyle: 'long' });
    }
    static formatLongDateTime(date: Date) {
        return date.toLocaleDateString(navigator.language, { dateStyle: 'long' }) + " " + date.toLocaleTimeString(navigator.language, { timeStyle: 'long' });
    }
    static formatLongTime(date: Date) {
        return date.toLocaleTimeString(navigator.language, { timeStyle: 'long' });
    }
    static format24HourTime(date: Date) {
        return `${date.getHours().toLocaleString("en-US", { minimumIntegerDigits: 2 })}:${date.getMinutes().toLocaleString("en-US", { minimumIntegerDigits: 2 })}`;
    }
    static formatLong24HourTime(date: Date) {
        return `${date.getHours().toLocaleString("en-US", { minimumIntegerDigits: 2 })}:${date.getMinutes().toLocaleString("en-US", { minimumIntegerDigits: 2 })}:${date.getSeconds().toLocaleString("en-US", { minimumIntegerDigits: 2 })}.${date.getMilliseconds().toLocaleString("en-US", { minimumIntegerDigits: 2 })}`;
    }
    static formatAddress(address: Address) {
        return (
            [[address.line1, address.line2]
            .filter(item => item && item.length > 0)
            .join(", "),
            [address.city, address.stateName, address.countryName, address.postcode]
            .filter(item => item && item.length > 0)
            .join(" ")]
            .filter(item => item && item.length > 0)
            .join(", ")
        );
    }
    static formatSchoolAddress(address: SchoolAddress) {
        return (
            [address.city, address.state, address.country]
            .filter(item => item && item.length > 0)
            .join(" ")
        );
    }
    static formatPhoneNumber(number: PhoneNumber) {
        return (
            `${number.type} ${number.phoneNumber}`
        );
    }
    static formatEmailAddress(email: EmailAddress) {
        return (
            email.address
        );
    }
    static toClassName(value: string) {
        return value.split(/(?=[A-Z])/).map(item => item.toLowerCase()).join("-");
    }
    static stripTimezone(value: Date) {
        return new Date(new Date(new Date(new Date(value.setUTCHours(0)).setUTCMinutes(0)).setUTCSeconds(0)).setUTCMilliseconds(0));
    }
}

export default Formatting;